import colors from "@constants/colors"
import styled from "styled-components"

const Button = styled.button`
  width: 180px;
  height: 40px;
  border: 1px solid gray;
  border-radius: 3px;
  background-color: ${colors.snow};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Jost", sans-serif;
  transition: all 0.6s;

  span {
    font-size: 20px;
    font-weight: 500;
  }

  &:hover {
    cursor: pointer;
    background-color: ${colors.lightestGray};
  }

  @media (max-width: 500px) {
    max-width: 100px;

    span {
      font-size: 16px;
    }
  }

  &:disabled {
    background-color: ${colors.mediumGray} !important;
    cursor: not-allowed;
  }
`

interface Props {
  label: string
  disabled?: boolean
  onClick: () => void
  className?: string
}

export default function ActionButton({
  className,
  label,
  onClick,
  disabled,
}: Props) {
  return (
    <>
      <Button className={className} onClick={onClick} disabled={disabled}>
        <span>{label}</span>
      </Button>
    </>
  )
}
